document.addEventListener('click', event => {
  const opener = event.target.closest('[data-dialog]');
  if (opener) {const dialog = document.getElementById(opener.dataset.dialog);if (dialog) {dialog._opener=opener;dialog.showModal();document.body.style.overflow='hidden';}}
  const closer = event.target.closest('[data-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target instanceof HTMLDialogElement) {const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  const stageLink=event.target.closest('[data-stage-link]');
  if(stageLink){const target=document.querySelector('[data-filter="'+stageLink.dataset.stageLink+'"]');if(target&&target.getAttribute('aria-pressed')!=='true')target.click();}
  const filter = event.target.closest('[data-filter]');
  if (filter && !window.matchMedia('(max-width: 600px)').matches) {const scope=filter.closest('.shop-section');const selected=filter.getAttribute('aria-pressed')==='true'?'all':filter.dataset.filter;scope.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===selected)));scope.querySelector('[data-rotation]').classList.toggle('filtered',selected!=='all');scope.querySelectorAll('[data-stage]').forEach(card=>card.hidden=selected!=='all'&&!card.dataset.stage.split(' ').includes(selected));}
  const thumb=event.target.closest('[data-gallery-image]');
  if(thumb){const image=document.querySelector('.main-product-image');if(image){image.src=thumb.dataset.galleryImage;image.removeAttribute('srcset');}}
});
document.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{document.body.style.overflow='';dialog._opener?.focus();}));
document.addEventListener('change',event=>{if(!event.target.matches('[data-variants]'))return;const option=event.target.selectedOptions[0];const price=document.querySelector('[data-current-price]');if(price)price.textContent=option.dataset.price;const add=document.querySelector('[data-add]');if(add){const available=option.dataset.available==='true';add.disabled=!available;add.textContent=available?add.dataset.ready+' +':add.dataset.sold;}if(option.dataset.image){const image=document.querySelector('.main-product-image');if(image){image.src=option.dataset.image;image.removeAttribute('srcset');}}const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});

const shopDropdown = document.querySelector('[data-shop-dropdown]');
if (shopDropdown) {
  document.addEventListener('click', event => {
    if (!shopDropdown.contains(event.target) || event.target.closest('.shop-dropdown-panel a')) shopDropdown.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && shopDropdown.open) {
      shopDropdown.open = false;
      shopDropdown.querySelector('summary').focus();
    }
  });
  document.addEventListener('focusin', event => {
    if (shopDropdown.open && !shopDropdown.contains(event.target)) shopDropdown.open = false;
  });
}
document.querySelectorAll('[data-collection-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));

document.querySelectorAll('[data-rotation]').forEach(track => {
  const scope = track.closest('.shop-section');
  const cards = Array.from(track.querySelectorAll('[data-stage]'));
  const filters = Array.from(scope.querySelectorAll('[data-filter]'));
  const mobile = window.matchMedia('(max-width: 600px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const status = scope.querySelector('[data-rotation-status]');
  if (!cards.length) return;
  let current = 0;
  let frame = 0;
  const paint = () => {
    cards.forEach((card, index) => card.classList.toggle('rotation-current', index === current));
    filters.forEach(button => button.setAttribute('aria-pressed', String(cards[current].dataset.stage.split(' ').includes(button.dataset.filter))));
    const activeFilter = filters.find(button => button.getAttribute('aria-pressed') === 'true');
    if (status && activeFilter) status.textContent = status.dataset.statusTemplate.replace('[stage]', activeFilter.dataset.stageLabel).replace('[number]', current + 1).replace('[total]', cards.length);
  };
  const goTo = index => {
    if (!mobile.matches) return;
    const card = cards[Math.max(0, Math.min(index, cards.length - 1))];
    track.scrollTo({left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
  };
  filters.forEach(button => button.addEventListener('click', () => {
    if (mobile.matches) goTo(cards.findIndex(card => card.dataset.stage.split(' ').includes(button.dataset.filter)));
  }));
  track.addEventListener('scroll', () => {
    if (!mobile.matches || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const left = track.getBoundingClientRect().left;
      const nearest = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0);
      if (nearest !== current) { current = nearest; paint(); }
    });
  }, {passive: true});
  track.addEventListener('keydown', event => {
    if (!mobile.matches || event.target !== track) return;
    if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      goTo(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  const reset = () => {
    cards.forEach(card => { card.hidden = false; card.classList.remove('rotation-current'); });
    track.classList.remove('filtered');
    filters.forEach(button => button.setAttribute('aria-pressed', 'false'));
    current = 0;
    track.scrollTo({left: 0, behavior: 'instant'});
    if (mobile.matches) { track.tabIndex = 0; paint(); }
    else { track.removeAttribute('tabindex'); if (status) status.textContent = ''; }
  };
  mobile.addEventListener('change', reset);
  scope.classList.add('rotation-ready');
  reset();
});

const scenes = Array.from(document.querySelectorAll('.bloom-hero,.bloom-story'));
if (scenes.length) {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sync = () => document.body.classList.toggle('motion-enabled', !preference.matches && !document.hidden);
  preference.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('motion-in-view', entry.isIntersecting));
  }, {threshold: 0.05});
  scenes.forEach(scene => observer.observe(scene));
  sync();
}

const holdView = document.querySelector('[data-hold-view]');
if (holdView) {
  const media = holdView.querySelector('[data-hold-media]');
  const caption = holdView.querySelector('[data-hold-caption]');
  const sources = Array.from(document.querySelectorAll('#shop .product-image,.chapter-image'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const blockedClicks = new WeakMap();
  let active = null;
  let returning = null;
  let closeTimer;
  let openFrame = 0;
  const cleanUp = () => {
    returning?.source.classList.remove('is-full-view-source');
    returning = null;
    holdView.hidden = true;
    media.replaceChildren();
  };
  const fromCard = (rect, target) => `translate(${rect.left - target.left}px,${rect.top - target.top}px) scale(${rect.width / target.width},${rect.height / target.height})`;
  const close = (instant = false) => {
    if (!active) return;
    cancelAnimationFrame(openFrame);
    returning = active;
    active = null;
    blockedClicks.set(returning.source, performance.now() + 800);
    holdView.classList.remove('is-open');
    media.style.transform = fromCard(returning.content.getBoundingClientRect(), returning.target);
    if (instant || reduceMotion.matches) cleanUp();
    else closeTimer = setTimeout(cleanUp, 240);
  };
  const open = (source, input) => {
    if (active) close(true);
    clearTimeout(closeTimer);
    if (returning) cleanUp();
    const content = source.querySelector('.tee-mockup') || source.querySelector('img');
    if (!content) return;
    const rect = content.getBoundingClientRect();
    const image = content.matches('img');
    const ratio = image ? (content.naturalWidth / content.naturalHeight || rect.width / rect.height) : content.classList.contains('garment--tee') ? 1160 / 1355 : 1;
    holdView.hidden = false;
    const width = Math.min(holdView.clientWidth - 24, (holdView.clientHeight - 80) * ratio);
    const height = width / ratio;
    const target = {width, height, left: (holdView.clientWidth - width) / 2, top: (holdView.clientHeight - height - 24) / 2};
    media.style.width = `${width}px`;
    media.style.height = `${height}px`;
    media.style.left = `${target.left}px`;
    media.style.top = `${target.top}px`;
    media.style.transform = fromCard(rect, target);
    const clone = content.cloneNode(true);
    clone.removeAttribute('id');
    const images = image ? [clone] : Array.from(clone.querySelectorAll('img'));
    images.forEach(img => { img.loading = 'eager'; img.draggable = false; });
    media.replaceChildren(clone);
    caption.textContent = source.dataset.holdTitle || source.closest('.product-card')?.querySelector('.product-name')?.textContent.trim() || content.alt || '';
    active = {source, content, target, ...input};
    source.classList.add('is-full-view-source');
    media.getBoundingClientRect();
    openFrame = requestAnimationFrame(() => {
      holdView.classList.add('is-open');
      media.style.transform = 'none';
    });
  };
  sources.forEach(source => {
    source.querySelectorAll('img').forEach(img => { img.draggable = false; });
    source.addEventListener('pointerdown', event => {
      if (event.button !== 0 || !event.isPrimary) return;
      blockedClicks.set(source, Infinity);
      open(source, {pointerId: event.pointerId, startX: event.clientX, startY: event.clientY});
      source.setPointerCapture(event.pointerId);
    }, {passive: true});
    source.addEventListener('pointermove', event => {
      if (active?.pointerId === event.pointerId && Math.hypot(event.clientX - active.startX, event.clientY - active.startY) > 12) close(true);
    }, {passive: true});
    source.addEventListener('lostpointercapture', event => {
      if (active?.source === source && active.pointerId === event.pointerId) close(true);
    });
    source.addEventListener('keydown', event => {
      if (!['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      if (!event.repeat) open(source, {key: event.key});
    });
    source.addEventListener('keyup', event => {
      if (active?.key === event.key) { event.preventDefault(); close(); }
    });
    source.addEventListener('blur', () => { if (active?.source === source) close(true); });
    source.addEventListener('contextmenu', event => event.preventDefault());
    source.addEventListener('dragstart', event => event.preventDefault());
  });
  document.addEventListener('click', event => {
    const source = event.target.closest('#shop .product-image,.chapter-image');
    if (source && blockedClicks.get(source) > performance.now()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('pointerup', event => {
    if (active?.pointerId === event.pointerId) close();
  }, true);
  window.addEventListener('pointercancel', () => close(true), true);
  window.addEventListener('blur', () => close(true));
  window.addEventListener('resize', () => close(true));
  document.addEventListener('visibilitychange', () => { if (document.hidden) close(true); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(true); });
}
